import React from 'react';
import { render } from 'react-dom';
// import runtime from 'serviceworker-webpack-plugin/lib/runtime';

import './sass/app.css';
import Root from './root';
import { configureStore, history } from './configureStore';
import registerServiceWorker from './registerServiceWorker';

// import './manifest.json';
// import './images/icon.png';

const store = configureStore();

render(<Root store={store} history={history} />, document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js